/**
 * Outstanding Items Component
 */

import React from 'react';
import './OutstandingItems.css';

const OutstandingItems = ({ title, items = [], loading = false, error = null, total = 0 }) => {
  const formatAmount = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 2,
    }).format(Math.abs(amount));
  };

  if (loading) {
    return (
      <div className="outstanding-section">
        <h3>{title}</h3>
        <div className="section-loading">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="outstanding-section">
        <h3>{title}</h3>
        <div className="section-error">{error}</div>
      </div>
    );
  }

  return (
    <div className="outstanding-section">
      <div className="section-header">
        <h3>{title}</h3>
        <span className="section-total">Total: {formatAmount(total)}</span>
      </div>

      {items && items.length > 0 ? (
        <div className="items-list">
          {items.map((item, idx) => (
            <div key={idx} className="item-row">
              <div className="item-info">
                <p className="item-party">{item.party}</p>
                <p className="item-type">{item.accountType}</p>
              </div>
              <div className="item-amount">{formatAmount(item.amount)}</div>
            </div>
          ))}
        </div>
      ) : (
        <div className="section-empty">No outstanding items</div>
      )}
    </div>
  );
};

export default OutstandingItems;
